import { useState } from 'react';
import toast from 'react-hot-toast';
import OrderController from '@/services/OrderController';
import useStore from '@/store/store';
import { MAX_ORDER_DELAY_MINUTES } from '@/utils/constants';

export const useGenericOrderModal = ({ isMasterOrAdmin, onCloseCancelModal }) => {
	const [isGenericOrderModalOpen, setIsGenericOrderModalOpen] = useState(false);
	const [selectedGenericOrderId, setSelectedGenericOrderId] = useState(null);

	const openGenericOrderModal = orderId => {
		setIsGenericOrderModalOpen(true);
		setSelectedGenericOrderId(orderId);
	};

	const onCloseGenericOrderModal = () => {
		setIsGenericOrderModalOpen(false);
		setSelectedGenericOrderId(null);
	};

	const onEditLiveOrder = async editedFields => {
		try {
			const fields = { ...(editedFields || {}) };
			if (fields.fee) {
				let fee = Number(`${fields.fee}`?.replaceAll(',', '.'));
				if (!isFinite(fee)) {
					toast.error('Η προμήθεια πρέπει να είναι νούμερο');
					return;
				}
				fields.fee = fee;
			} else {
				delete fields.fee;
			}

			if (fields.shopFee) {
				let shopFee = Number(`${fields.shopFee}`?.replaceAll(',', '.'));
				if (!isFinite(shopFee)) {
					toast.error('Η χρέωση καταστήματος πρέπει να είναι νούμερο');
					return;
				}
				fields.shopFee = shopFee;
			} else {
				delete fields.shopFee;
			}
			const res = await OrderController.editLiveOrder(selectedGenericOrderId, fields);

			if (!res.error) {
				toast.success('Η Παραγγελία τροποποιήθηκε!');
				onCloseGenericOrderModal();
				return;
			}
			toast.error('El problemo edit');
		} catch (err) {
			toast.error(`El problemo edit.. ${err}`);

			console.log('on editok err: ', err);
		}
	};

	// minutes is free text: both '12,5' and '12.5' have to work.
	const onChangeOrderDelay = async minutesText => {
		try {
			const minutes = Number(`${minutesText ?? ''}`.trim().replaceAll(',', '.'));

			if (`${minutesText ?? ''}`.trim() === '' || !isFinite(minutes)) {
				toast.error('Ο χρόνος πρέπει να είναι αριθμός');
				return;
			}

			if (minutes < 0 || minutes > MAX_ORDER_DELAY_MINUTES) {
				toast.error(`Ο χρόνος πρέπει να είναι από 0 έως ${MAX_ORDER_DELAY_MINUTES} λεπτά`);
				return;
			}

			const res = await OrderController.changeOrderDelay(selectedGenericOrderId, minutes);

			if (!res?.error) {
				toast.success('Ο χρόνος ετοιμασίας άλλαξε!');
				onCloseGenericOrderModal();
				return;
			}

			toast.error(
				typeof res.error === 'string' ? res.error : 'Κάποιο πρόβλημα προέκυψε με τον χρόνο',
			);
		} catch (err) {
			console.log('on change order delay err: ', err);
			toast.error(`Κάποιο πρόβλημα προέκυψε${err}`);
		}
	};

	const onCancelOrder = async () => {
		try {
			if (!isMasterOrAdmin) {
				toast.error('Κάποιο πρόβλημα προέκυψε');
				return;
			}

			const orderId = selectedGenericOrderId;
			if (!orderId) {
				setIsGenericOrderModalOpen(false);
				return;
			}

			const res = await OrderController.cancel({
				orderId,
			});

			if (!res?.error) {
				toast.success('Η Παραγγελία ακυρώθηκε');
				onCloseCancelModal();
				onCloseGenericOrderModal();
			} else {
				toast.error(
					`Κάποιο πρόβλημα προέκυψε${typeof res.error === 'string' || res?.code ? ':' : ''}${
						typeof res.error === 'string' ? ` ${res.error}` : ''
					}${res?.code ? ` (${res.code})` : ''}`,
				);
			}
		} catch (err) {
			console.log(err);
			toast.error(`Κάποιο πρόβλημα προέκυψε${err}`);
		}
	};

	const onCancelDraftOrder = async orderId => {
		try {
			const res = await OrderController.cancelDraft({
				orderId,
			});

			if (!res?.error) {
				toast.success('Η Παραγγελία ακυρώθηκε');
				useStore.getState().removeDraftOrderId(orderId);
			} else {
				toast.error(
					`Κάποιο πρόβλημα προέκυψε${typeof res.error === 'string' || res?.code ? ':' : ''}${
						typeof res.error === 'string' ? ` ${res.error}` : ''
					}${res?.code ? ` (${res.code})` : ''}`,
				);
			}
		} catch (err) {
			console.log(err);
			toast.error(`Κάποιο πρόβλημα προέκυψε${err}`);
		}
	};

	return {
		isGenericOrderModalOpen,
		selectedGenericOrderId,
		openGenericOrderModal,
		onCloseGenericOrderModal,
		onEditLiveOrder,
		onChangeOrderDelay,
		onCancelOrder,
		onCancelDraftOrder,
	};
};
